import moment from 'moment';
import 'moment/locale/es';

const useMoment = (value, format) =>
  moment(value || new Date()).format(format || 'DD [de] MMMM YYYY');

export default useMoment;
